// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2490":"f436bc0c79113f0f","5109":"a487f46eaabd9737"}[chunkId] + ".css";
};